var map = {
	"./figueira.jpg": "64a0",
	"./foto-fundo.jpg": "2ede",
	"./hero-festa2.jpg": "92b1",
	"./hero-home.jpg": "f74b",
	"./mural-mensagens.jpg": "20f9",
	"./presentes.jpg": "ba99",
	"./presentes/caixa-mila.jpg": "d809",
	"./presentes/coliseu.jpg": "b925",
	"./presentes/hotel.jpg": "500a",
	"./presentes/pompeia.jpg": "59d4",
	"./soro-noite.jpg": "49a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";